<template>
  <div class="centralFileBackup">
    <div class="centralFileBackup">
      <div class="centralFileBackup-bottom">
        <div class="centralFileBackup-bottom-left">
          <div class="left_top">
            <div class="setUp" :style="{'background':isOpen==true?'#EFFBF8':'#E5E8F1'}">
              <div v-if="!isOpen">
                <img :src="close_png" alt="关闭" />
                <span>自动备份已关闭</span>
              </div>
              <div v-else>
                <img :src="open_png" alt="开启" />
                <span>自动备份已开启</span>
              </div>
              <img :src="setUp_png" alt="设置" style="cursor:pointer" @click="autoBackupOpen" />
            </div>
          </div>
          <el-tree ref="dicTree" class="dicTree" highlight-current node-key="id"
            :props="defaultProps" lazy :load="loadNode" @node-click="nodeClick" @node-expand="treeExpand" @node-collapse="treeCollapse">
            <template #default="{ data }">
              <span class="span-ellipsis" :title="dataTitle(data)">
                <img v-if="data.folderType===1" :src="centralFileBackupPrj_png" alt="项目" style="width: 18px;height: 17px;" />
                <img v-if="data.isFolder===1&&data.folderType!==1&&data.isSys===1" :src="tableSysDoc_png" alt="文件" />
                <img v-if="data.isFolder===1&&data.folderType!==1&&data.isSys===0" :src="treeZiDoc" alt="文件" />
                <span class="nameStyle">{{ data.name }}</span>
              </span>
            </template>
          </el-tree>
        </div>
        <div v-if="flag" class="centralFileBackup-bottom-middle">
          <div class="middle_top">
            <div class="middle_top_left">
              <img :src="revit_png" alt="revit" />
              <p>{{ centralFileDetail.revitNameOrVersion }}</p>
            </div>
            <div class="middle_top_right">
              <h2>{{ centralFileDetail.fileName }}</h2>
              <p v-if="!isRecycle">上次备份时间: {{ centralFileDetail.backUpTime }}</p>
              <p>创建时间: {{ centralFileDetail.createTime }}</p>
              <!-- <p>当前模型大小: {{ centralFileDetail.fileSize }}</p> -->
            </div>
          </div>
          <div class="tableList">
            <div v-if="!isRecycle" class="operations">
              <span>备份时间:</span>
              <el-date-picker
                v-model="timeData"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                @change="queryCentralTable">
              </el-date-picker>
            </div>
            <el-table ref="table" class="jk-table" height="85%" size="small" :data="centralFileTable"
              style="width: 100%" border highlight-current-row>
              <el-table-column v-if="!isRecycle" prop="orderNumber" label="序号" align="center" show-overflow-tooltip width="100" />
              <el-table-column v-if="!isRecycle" prop="backupTime" label="备份时间" align="center" show-overflow-tooltip />
              <el-table-column v-if="isRecycle" prop="dateTime" label="删除时间" show-overflow-tooltip />
              <el-table-column label="操作" width="180">
                <template #default="{ row }">
                  <el-button type="text" size="small" style="font-size: 18px" @click="downloadStatus(centralFile.id,centralFile.prjId,centralFile.name,row)">
                    下载
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else class="centralFileBackup-no">
          <img :src="noData_png" alt="暂无数据" />
          <p>请选择中心文件节点，再进行数据查看</p>
        </div>
      </div>
    </div>
    <el-dialog v-if="autoBackupVisible" v-dialogDrag title="自动备份设置" :visible="autoBackupVisible" width="500px" :before-close="autoBackupClose"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <el-form ref="autoBackupForm" :model="autoBackupForm" label-width="130px" :rules="rules" size="small">
          <el-form-item label="开始时间:" prop="startTime" label-width="130px">
            <el-date-picker
              v-model="autoBackupForm.startTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              style="width:95%">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备份周期:" prop="type" label-width="130px">
            <el-radio-group v-model="autoBackupForm.type">
              <el-radio :label="0">天</el-radio>
              <!-- <el-radio :label="1">周</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="每隔:" prop="intervalDay" label-width="130px">
            <el-input v-model.trim="autoBackupForm.intervalDay" style="width:95%" size="small">
              <template slot="append">天发生一次</template>
            </el-input>
          </el-form-item>
          <el-form-item label="最多保留版本数:" prop="reservedVersion" label-width="130px">
            <el-input v-model.trim="autoBackupForm.reservedVersion" style="width:95%" size="small">
              <template slot="append">个</template>
            </el-input>
          </el-form-item>
          <el-form-item label="状态:" prop="status" label-width="130px">
            <el-radio-group v-model="autoBackupForm.status">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="autoBackupClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <div v-if="downFileList.length>0" class="downFileList">
      <div class="file-panel">
        <div class="file-title">
          <h3>下载列表</h3>
          <div class="operate">
            <el-button :title="collapse ? '展开': '折叠'" type="text" @click="fileListShow">
              <i id="uploadFrameBtn" :class="collapse ? 'el-icon-copy-document':'el-icon-minus'"></i>
            </el-button>
            <el-button type="text" title="关闭" @click="close">
              <i class="el-icon-close"></i>
            </el-button>
          </div>
        </div>
        <div v-if="!collapse" style="height: 300px">
          <ul class="file-list">
            <li v-for="(item,index) in downFileList" :key="index">
              <div class="down-file-name">
                {{ item.name }}
              </div>
              <div class="down-file-orderNumber">
                序号: {{ item.orderNumber }}
              </div>
              <div class="down-file-status">
                <span v-if="item.status===1">失败</span>
                <span v-if="item.status===2">下载中</span>
                <span v-if="item.status===3">成功</span>
              </div>
              <div class="down-file-actions">
                <i v-if="item.status===1" id="uploadFrameBtn" class="el-icon-caret-right" title="重新下载" style="margin-right:8px" @click="againDown(item)"></i>
                <i class="el-icon-close" title="移除" @click="remove(item)"></i>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const autoBackupParam = () => ({
  id: "",
  startTime: '',
  type: 0,
  intervalDay: '',
  reservedVersion: '7',
  status: 1,
  enterpriseId: ''
});
import { mapState } from "vuex";
import centralFileBackupRequest from "@/CommonDP/service/centralFileBackup-service";
import { downloadFile, revitBackUpDownload, revitServerDownload } from "@/CommonDP/utils";
export default {
  name: "CentralFileBackup",
  components: {},
  data() {
    return {
      centralFileBackupPrj_png: require("@/CommonDP/assets/projectMg/centralFileBackupPrj.png"),
      tableSysDoc_png: require("@/CommonDP/assets/projectMg/treeSysDoc.png"),
      treeZiDoc: require("@/CommonDP/assets/projectMg/treeZiDoc.png"),
      close_png: require("@/CommonDP/assets/settings/centralFileBackup/close.png"),
      open_png: require("@/CommonDP/assets/settings/centralFileBackup/open.png"),
      setUp_png: require("@/CommonDP/assets/settings/centralFileBackup/setUp.png"),
      revit_png: require("@/CommonDP/assets/settings/centralFileBackup/revit.png"),
      noData_png: require("@/CommonDP/assets/settings/centralFileBackup/noData.png"),
      centralFileTable: [], // 列表
      defaultProps: {
        label: "name",
        children: "childList",
        isLeaf: "leaf"
      },
      isOpen: false,
      timeData: null,
      autoBackupVisible: false,
      autoBackupForm: autoBackupParam(),
      rules: {
        startTime: [{ required: true, message: "请选择开始时间", trigger: "change" }],
        intervalDay: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              const boolean = new RegExp("^[1-9][0-9]*$").test(value);
              if (!boolean) {
                callback(new Error("请输入正整数"));
              } else {
                callback();
              }
            } else {
              callback('请输入时间间隔');
            }
          },
          trigger: "blur"
        }],
        reservedVersion: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              const boolean = new RegExp("^[1-9][0-9]*$").test(value);
              if (!boolean) {
                callback(new Error("请输入正整数"));
              } else {
                callback();
              }
            } else {
              callback('请输入最多保留版本数');
            }
          },
          trigger: "blur"
        }]
      },
      flag: false,
      centralFile: {},
      centralFileNode: {},
      centralFileDetail: {},
      prjId: '',
      begin: true,
      downFileList: [],
      collapse: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo,
      downFileListS: (state) => state.centralFileBackup.downFileList
    }),
    isRecycle() {
      return this.centralFileNode.parent.data?.id === 'recycle';
    }

  },
  watch: {},

  created() {
    this.downFileList = this.downFileListS;
    this.getRevitBackUpRules();
  },
  methods: {
    // 单个树展开
    treeExpand(data, node) {
      this.centralFileNode = node;
      if (data.isFolder === 0) {
        this.flag = true;
        this.begin = true;
        this.centralFile = data;
        this.queryCentralFile();
        this.queryCentralTable();
      } else {
        this.flag = false;
        this.begin = false;
        this.centralFile = {};
      }
    },
    // 单个树收起
    treeCollapse(data, node) {
      this.centralFileNode = node;
      if (data.isFolder === 0) {
        this.flag = true;
        this.begin = true;
        this.centralFile = data;
        this.queryCentralFile();
        this.queryCentralTable();
      } else {
        this.flag = false;
        this.begin = false;
        this.centralFile = {};
      }
    },
    dataTitle(data) {
      return data.dateTime ? data.name + '  ' + data.dateTime : data.name;
    },
    againDown(val) {
      const fileId = val.fileId;
      const prjId = val.prjId;
      const name = val.name;
      const row = val.row;
      this.downloadStatus(fileId, prjId, name, row);
    },
    remove(val) {
      this.$confirm('移除此下载文件,确定移除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (val.status === 2) {
            val.remove = true;
          } else {
            const index = this.downFileList.findIndex((item) => item.id === val.id);
            this.downFileList.splice(index, 1);
            this.$store.dispatch("setDownFileList", this.downFileList);
          }
        });
    },
    close() {
      this.$confirm('下载列表关闭,未下载成功的文件将取消下载,确定关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.begin = false;
          this.downFileList = [];
          this.$store.dispatch("setDownFileList", this.downFileList);
        });
    },
    // 折叠
    fileListShow() {
      this.collapse = !this.collapse;
    },
    nodeClick(data, node) {
      this.centralFileNode = node;
      if (data.isFolder === 0) {
        this.flag = true;
        this.begin = true;
        this.centralFile = data;
        this.queryCentralFile();
        this.queryCentralTable();
      } else {
        this.flag = false;
        this.begin = false;
        this.centralFile = {};
      }
    },
    async queryCentralFile() {
      this.centralFileDetail = {};
      const fileId = this.centralFile.id;
      const prjId = this.prjId;
      const res = await centralFileBackupRequest.getCentralFile(fileId, prjId);
      this.centralFileDetail = res.data;
    },
    async queryCentralTable() {
      this.centralFileTable = [];
      if (!this.isRecycle) {
        let startTime = '';
        let endTime = '';
        if (this.timeData) {
          startTime = this.timeData[0];
          endTime = this.timeData[1];
        } else {
          startTime = '';
          endTime = '';
        }
        const res = await centralFileBackupRequest.getRevitBackUpRecordList(startTime, endTime);
        this.centralFileTable = res.data;
      } else {
        this.centralFileTable.push(this.centralFile);
      }
    },
    async loadNode(node, resolve) {
      if (node.level === 0) {
        const result = await centralFileBackupRequest.getRevitBackUpTree(this.enterpriseId, 0);
        return resolve(result.data);
      } else {
        if (node.data.folderType === 1) {
          this.prjId = node.data.id;
          centralFileBackupRequest.getRevitBackUpTree(this.enterpriseId, node.data.id).then(({ data }) => {
            return resolve(data);
          });
        } else {
          if (node.data.childList) {
            return resolve(node.data.childList);
          } else {
            return resolve([]);
          }
        }
      }
    },
    async getRevitBackUpRules() {
      const res = await centralFileBackupRequest.getRevitBackUpRules();
      if (res.data) {
        this.autoBackupForm = res.data;
        this.isOpen = res.data.status === 1;
      }
    },
    submit() {
      this.$refs.autoBackupForm.validate(async (valid) => {
        if (!valid) return;
        this.autoBackupForm.enterpriseId = this.enterpriseId;
        await centralFileBackupRequest.revitBackUpSave(this.autoBackupForm);
        this.autoBackupVisible = false;
        this.$message({
          type: "success",
          message: "自动备份设置成功"
        });
        await this.getRevitBackUpRules();
      });
    },
    autoBackupOpen() {
      if (!this.autoBackupForm.id) {
        this.autoBackupForm = autoBackupParam();
      } else {
        this.getRevitBackUpRules();
      }
      this.autoBackupVisible = true;
    },
    autoBackupClose() {
      this.autoBackupVisible = false;
    },
    downloadStatus(fileId, prjId, name, row) {
      if (!this.isRecycle) {
        const id = fileId + row.orderNumber;
        const ischongming = this.downFileList.some((item) => {
          return item.id === id;
        });
        if (!ischongming) {
          const fileItme = {
            fileId,
            prjId,
            row,
            name,
            orderNumber: row.orderNumber,
            status: 2,
            id: id,
            remove: false
          };
          this.downFileList.push(fileItme);
          this.$store.dispatch("setDownFileList", this.downFileList);
        }
        try {
          centralFileBackupRequest.getDownloadStatus(fileId, prjId, row.id, row.backupFolder).then(({ data }) => {
            // data 1 失败 2 进行中 3 成功
            const index = this.downFileList.findIndex((item) => item.id === id);
            this.downFileList[index].status = data;
            if (data === 2 && this.begin && !this.downFileList[index].remove) {
              setTimeout(() => {
                this.downloadStatus(fileId, prjId, name, row);
              }, 5000);
            } else if (data === 2 && this.begin && this.downFileList[index].remove) {
              this.downFileList.splice(index, 1);
              this.$store.dispatch("setDownFileList", this.downFileList);
            } else if (data === 3) {
              this.downloadFile(fileId, row.backupFolder);
            }
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        this.downloadFile(fileId);
      }
    },
    downloadFile(fileId, backupFolder) {
      const downzipurl = this.isRecycle ? revitServerDownload(fileId) : revitBackUpDownload(fileId, backupFolder);
      downloadFile(downzipurl);
    }
  }
};
</script>

<style lang="scss" scoped>
.centralFileBackup {
  width: 100%;
  height: 100%;
  .centralFileBackup {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #eff1f6;
    .centralFileBackup-bottom {
      flex: 1;
      display: flex;
      overflow: hidden;
    }
  }
  .centralFileBackup-bottom-left {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 264px;
    border-right: 1px solid #f2f2f2;
    background-color: #fff;
    .left_top {
      .setUp{
        display: flex;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        align-items: center;
        padding: 18px;
        justify-content: space-between;
        div{
          display: flex;
          align-items: center;
        }
        img{
          width:18px;
          height:18px;
          margin-right: 10px;
        }
      }
    }
    .dicTree {
      overflow: auto;
      flex: 1;
      font-size: 14px;
      margin-top: 15px;
      img {
        margin-right: 6px;
      }
      .span-ellipsis {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
        align-items: stretch;
        .nameStyle{
          font-size:14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      /deep/ .el-tree-node__content {
        margin:7px 0 !important;
      }
    }
  }
  .centralFileBackup-bottom-middle,
  .centralFileBackup-no{
    overflow: hidden;
    flex: 1;
    border-right: 1px solid #f2f2f2;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    background-color: #fff;
    .middle_top {
      padding-top: 46px;
      padding-left: 40px;
      height: 183px;
      border-bottom: 1px solid #e5e8f1;
      display: flex;
      .middle_top_left{
        p{
          color: #464C5B;
          font-size: 14px;
          text-align: center;
        }
      }
      .middle_top_right{
        margin-left: 32px;
        line-height: 31px;
        h2{
          color: #464C5B;
          font-size: 20px;
        }
        p{
          color: #464C5B;
          font-size: 14px;
          letter-spacing:1px;
        }
      }
    }
    .tableList {
      flex: 1;
      overflow: hidden;
      padding: 26px 47px 0 47px;
      .operations{
        margin-bottom: 24px;
        span{
          margin-right: 20px;
        }
      }
    }
  }
  .centralFileBackup-no{
    align-items: center;
    justify-content: center;
    img{
      width: 447px;
      height: 447px;
    }
    p{
      color:var(--key-color);
      font-size:16px;
      font-weight: 400;
    }
  }
  .span-ellipsis {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .downFileList{
    position: fixed;
    z-index: 9999;
    right: 36px;
    bottom: 33px;
    .file-panel {
      background-color: #ffffffe6;
      border-radius: 7px 7px 7px 7px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

      .file-title {
        font-size: 14px;
        width: 580px;
        display: flex;
        align-items: center;
        height: 48px;
        padding: 0 15px;
        border-bottom: 1px solid #ebeefa;

        .operate {
          flex: 1;
          text-align: right;
          line-height: 30px;
        }
      }

      .file-list::-webkit-scrollbar {
        width: 5px;
        height: 10px;
      }

      .file-list::-webkit-scrollbar-track {
        background: #eee;
        border-radius: 2px;
      }

      .file-list::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 10px;
      }

      .file-list::-webkit-scrollbar-thumb:hover {
        background: #c4c6cc;
      }

      .file-list {
        height: 300px;
        overflow-x: hidden;
        overflow-y: auto;
        border-radius: 0px 0px 7px 7px;
        width: 580px;
        margin: 0 auto;

        > li {
          font-size: 14px;
          height: 58px;
          display: flex;
          border-bottom: 1px solid #2e5bff1a;

          > div {
            height: 100%;
            line-height: 58px;
          }
        }
        .down-file-name{
          width: 45%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-indent: 14px;
        }
        .down-file-orderNumber{
          width: 13%;
          text-indent: 10px;
        }
        .down-file-status{
          width: 24%;
          text-indent: 20px;
        }
        .down-file-actions{
          width: 10%;
          font-size: 18px;
          cursor:pointer;
        }
      }
      &.collapse {
        .file-title {
          background-color: #e7ecf2;
        }
      }
    }
  }
}
</style>
